export default __webpack_public_path__ + "545e50a3684c491add5c8956918c5a86.png";